export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500/10 via-accent-500/10 to-secondary-500/10 rounded-2xl border border-background-200 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
                客户端
              </span>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
                随时随地，下拉式全集阅读
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-lg">
                亲亲漫画网针对移动端深度优化，下拉式阅读在手机上同样流畅。无需下载APP，浏览器打开即可享受完整的漫画全集阅读体验，完结日漫韩漫随时随地在线看。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50 border border-background-200">
                  <span className="w-5 h-5 flex items-center justify-center text-secondary-600">
                    <i className="ri-android-line"></i>
                  </span>
                  <span className="text-xs text-foreground-600">浏览器即用</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50 border border-background-200">
                  <span className="w-5 h-5 flex items-center justify-center text-secondary-600">
                    <i className="ri-apple-line"></i>
                  </span>
                  <span className="text-xs text-foreground-600">iOS 完美适配</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50 border border-background-200">
                  <span className="w-5 h-5 flex items-center justify-center text-secondary-600">
                    <i className="ri-wifi-off-line"></i>
                  </span>
                  <span className="text-xs text-foreground-600">支持离线下载</span>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0 w-full max-w-xs">
              <div className="aspect-[3/4] rounded-2xl overflow-hidden border-4 border-background-50">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20held%20in%20hand%20displaying%20colorful%20manga%20reading%20interface%20with%20scroll%20design%2C%20warm%20cream%20background%2C%20clean%20modern%20UI%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography&width=600&height=800&seq=app-manga-01&orientation=portrait"
                  alt="亲亲漫画网 - 手机端下拉式全集阅读"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}